export default __webpack_public_path__ + "static/media/twitter.1bd5fc45.svg";